var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Edit",
    clipPath: "url(#clip0_6867_606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19898 2.3656C1.49982 2.06476 1.90784 1.89575 2.33329 1.89575H6.41663C6.65825 1.89575 6.85413 2.09163 6.85413 2.33325C6.85413 2.57488 6.65825 2.77075 6.41663 2.77075H2.33329C2.13991 2.77075 1.95444 2.84757 1.81769 2.98432C1.68095 3.12107 1.60413 3.30653 1.60413 3.49992V11.6666C1.60413 11.86 1.68095 12.0454 1.81769 12.1822C1.95444 12.3189 2.13991 12.3958 2.33329 12.3958H10.5C10.6933 12.3958 10.8788 12.3189 11.0156 12.1822C11.1523 12.0454 11.2291 11.86 11.2291 11.6666V7.58325C11.2291 7.34163 11.425 7.14575 11.6666 7.14575C11.9082 7.14575 12.1041 7.34163 12.1041 7.58325V11.6666C12.1041 12.092 11.9351 12.5001 11.6343 12.8009C11.3334 13.1017 10.9254 13.2708 10.5 13.2708H2.33329C1.90784 13.2708 1.49981 13.1017 1.19898 12.8009C0.898136 12.5001 0.729126 12.092 0.729126 11.6666V3.49992C0.729126 3.07447 0.898136 2.66644 1.19898 2.3656Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6666 1.53345C11.4545 1.53345 11.251 1.61773 11.101 1.76774L5.64502 7.22372L5.26792 8.7321L6.7763 8.355L12.2323 2.89902C12.3823 2.74901 12.4666 2.54554 12.4666 2.33338C12.4666 2.12123 12.3823 1.91776 12.2323 1.76774C12.0823 1.61773 11.8788 1.53345 11.6666 1.53345ZM10.4823 1.14902C10.7964 0.834913 11.2224 0.658447 11.6666 0.658447C12.1109 0.658447 12.5369 0.834913 12.851 1.14902C13.1651 1.46314 13.3416 1.88916 13.3416 2.33338C13.3416 2.77761 13.1651 3.20363 12.851 3.51774L7.30933 9.05941C7.25326 9.11548 7.183 9.15526 7.10608 9.17449L4.77274 9.75782C4.62366 9.79509 4.46594 9.75141 4.35728 9.64274C4.24861 9.53408 4.20493 9.37636 4.2422 9.22728L4.82553 6.89394C4.84476 6.81702 4.88454 6.74676 4.94061 6.69069L10.4823 1.14902Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6867_606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.3c951e716cf53280e14d113af51fc40b.svg";
export { ForwardRef as ReactComponent };